'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _index = require('../../index');

var _index2 = _interopRequireDefault(_index);

var _dispatcher = require('../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _velocityVector = require('velocity-vector');

var _velocityVector2 = _interopRequireDefault(_velocityVector);

require('velocity-vector/velocity.ui');

var _SettingsStore = require('../../settings/SettingsStore');

var _SettingsStore2 = _interopRequireDefault(_SettingsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CALLOUT_ANIM_DURATION = 1000; /*
                                  Copyright 2015, 2016 OpenMarket Ltd
                                  Copyright 2017 Vector Creations Ltd
                                  
                                  Licensed under the Apache License, Version 2.0 (the "License");
                                  you may not use this file except in compliance with the License.
                                  You may obtain a copy of the License at
                                  
                                      http://www.apache.org/licenses/LICENSE-2.0
                                  
                                  Unless required by applicable law or agreed to in writing, software
                                  distributed under the License is distributed on an "AS IS" BASIS,
                                  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                  See the License for the specific language governing permissions and
                                  limitations under the License.
                                  */

module.exports = _react2.default.createClass({
    displayName: 'BottomLeftMenu',

    propTypes: {
        collapsed: _react2.default.PropTypes.bool.isRequired
    },

    getInitialState: function getInitialState() {
        return {
            directoryHover: false,
            roomsHover: false,
            homeHover: false,
            peopleHover: false,
            settingsHover: false
        };
    },

    componentWillMount: function componentWillMount() {
        this._dispatcherRef = _dispatcher2.default.register(this.onAction);
        this._peopleButton = null;
        this._directoryButton = null;
        this._createRoomButton = null;
        this._lastCallouts = {};
    },

    componentWillUnmount: function componentWillUnmount() {
        _dispatcher2.default.unregister(this._dispatcherRef);
    },

    // Room events
    onDirectoryClick: function onDirectoryClick() {
        _dispatcher2.default.dispatch({ action: 'view_room_directory' });
    },

    onDirectoryMouseEnter: function onDirectoryMouseEnter() {
        this.setState({ directoryHover: true });
    },

    onDirectoryMouseLeave: function onDirectoryMouseLeave() {
        this.setState({ directoryHover: false });
    },

    onRoomsClick: function onRoomsClick() {
        _dispatcher2.default.dispatch({ action: 'view_create_room' });
    },

    onRoomsMouseEnter: function onRoomsMouseEnter() {
        this.setState({ roomsHover: true });
    },

    onRoomsMouseLeave: function onRoomsMouseLeave() {
        this.setState({ roomsHover: false });
    },

    // Home button events
    onHomeClick: function onHomeClick() {
        _dispatcher2.default.dispatch({ action: 'view_home_page' });
    },

    onHomeMouseEnter: function onHomeMouseEnter() {
        this.setState({ homeHover: true });
    },

    onHomeMouseLeave: function onHomeMouseLeave() {
        this.setState({ homeHover: false });
    },

    // People events
    onPeopleClick: function onPeopleClick() {
        _dispatcher2.default.dispatch({ action: 'view_create_chat' });
    },

    onPeopleMouseEnter: function onPeopleMouseEnter() {
        this.setState({ peopleHover: true });
    },

    onPeopleMouseLeave: function onPeopleMouseLeave() {
        this.setState({ peopleHover: false });
    },

    // Settings events
    onSettingsClick: function onSettingsClick() {
        _dispatcher2.default.dispatch({ action: 'view_user_settings' });
    },

    onSettingsMouseEnter: function onSettingsMouseEnter() {
        this.setState({ settingsHover: true });
    },

    onSettingsMouseLeave: function onSettingsMouseLeave() {
        this.setState({ settingsHover: false });
    },

    onAction: function onAction(payload) {
        var calloutElement = void 0;
        switch (payload.action) {
            // Incoming instruction: dance!
            case 'callout_start_chat':
                calloutElement = this._peopleButton;
                break;
            case 'callout_room_directory':
                calloutElement = this._directoryButton;
                break;
            case 'callout_create_room':
                calloutElement = this._createRoomButton;
                break;
        }
        if (calloutElement) {
            var lastCallout = this._lastCallouts[payload.action];
            var now = Date.now();
            if (lastCallout == undefined || lastCallout < now - CALLOUT_ANIM_DURATION) {
                this._lastCallouts[payload.action] = now;
                (0, _velocityVector2.default)(_reactDom2.default.findDOMNode(calloutElement), "callout.bounce", CALLOUT_ANIM_DURATION);
            }
        }
    },

    // Get the label/tooltip to show
    getLabel: function getLabel(label, show) {
        if (show) {
            var RoomTooltip = _index2.default.getComponent("rooms.RoomTooltip");
            return _react2.default.createElement(RoomTooltip, { className: 'mx_BottomLeftMenu_tooltip', label: label });
        }
    },

    _collectPeopleButton: function _collectPeopleButton(e) {
        this._peopleButton = e;
    },

    _collectDirectoryButton: function _collectDirectoryButton(e) {
        this._directoryButton = e;
    },

    _collectCreateRoomButton: function _collectCreateRoomButton(e) {
        this._createRoomButton = e;
    },

    render: function render() {
        var HomeButton = _index2.default.getComponent('elements.HomeButton');
        var StartChatButton = _index2.default.getComponent('elements.StartChatButton');
        var RoomDirectoryButton = _index2.default.getComponent('elements.RoomDirectoryButton');
        var CreateRoomButton = _index2.default.getComponent('elements.CreateRoomButton');
        var SettingsButton = _index2.default.getComponent('elements.SettingsButton');
        var GroupsButton = _index2.default.getComponent('elements.GroupsButton');

        var groupsButton = !_SettingsStore2.default.getValue("TagPanel.enableTagPanel") ? _react2.default.createElement(GroupsButton, { tooltip: true }) : null;

        return _react2.default.createElement(
            'div',
            { className: 'mx_BottomLeftMenu' },
            _react2.default.createElement(
                'div',
                { className: 'mx_BottomLeftMenu_options' },
                _react2.default.createElement(HomeButton, { tooltip: true }),
                _react2.default.createElement(
                    'div',
                    { ref: this._collectPeopleButton },
                    _react2.default.createElement(StartChatButton, { tooltip: true })
                ),
                _react2.default.createElement(
                    'div',
                    { ref: this._collectDirectoryButton },
                    _react2.default.createElement(RoomDirectoryButton, { tooltip: true })
                ),
                _react2.default.createElement(
                    'div',
                    { ref: this._collectCreateRoomButton },
                    _react2.default.createElement(CreateRoomButton, { tooltip: true })
                ),
                groupsButton,
                _react2.default.createElement(
                    'span',
                    { className: 'mx_BottomLeftMenu_settings' },
                    _react2.default.createElement(SettingsButton, { tooltip: true })
                )
            )
        );
    }
});
//# sourceMappingURL=BottomLeftMenu.js.map